<template>
    <div class="container" >
        <h1>Хичээлүүд</h1>
        <ul>
            <li v-for="(school, index) in schools" v-bind:key="'school'+index">
                <h4>{{school.name}}</h4>
                <ul>
                    <li v-for="(department, index) in school.departments" v-bind:key="department.id">
                        <h5>{{department.name}}</h5>
                         <ol>
                            <li v-for="(program, index) in department.programs" v-bind:key="program.id">
                                <h5>{{program.name}}</h5>
                                <ol>
                                    <li v-for="(lesson, index) in program.lessons" v-bind:key="lesson.id" @click="goDetail(lesson)" style="cursor:pointer;margin-bottom:10px">
                                        <h6 class="text-success">{{lesson.name}}</h6>
                                         <span class="text-danger ml-2">{{lesson.teacherFirstName}}</span>

                                        <span class="text-primary ml-2" v-if="lesson.numberOfTopics">    
                                            Сэдвийн тоо: {{lesson.numberOfTopics}}
                                            
                                        </span>
                                        <span  class=" ml-2" v-if="lesson.numberOfVideos">Video тоо: {{lesson.numberOfVideos}}</span>
                                    
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                </ul>
            </li>
        </ul>

        <h3>Бүх хичээлүүд</h3>
        <ol>
            <li v-for="(lesson, index) in lessons" v-bind:key="'lesson_'+lesson.id" @click="goDetail(lesson)"  style="cursor:pointer; margin-bottom: 12px;">
                <h4>{{lesson.name}}</h4>
                <span class="text-danger ml-2">{{lesson.teacherFirstName}}</span>

                    <span class="text-primary ml-2" v-if="lesson.numberOfTopics">    
                        Сэдвийн тоо: {{lesson.numberOfTopics}}
                        
                    </span>
                    <span  class=" ml-2" v-if="lesson.numberOfVideos">Video тоо: {{lesson.numberOfVideos}}</span>
                <hr/>
                <!-- <ul>
                    <li v-for="(type, index) in types" >
                        {{type.name}}
                        <ul>
                            <li v-for="(topic, index) in lesson[type.id]" >
                                <span v-if="topic.name!=null">{{topic.name}}</span>
                                -<span v-if="topic.files!=null">{{topic.files.length}}</span>
                            </li>
                        </ul>
                    </li>
                </ul> -->
                
            </li>
        </ol>

    </div>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
    name: "AllLessons",
    data() {
        return {
            schools:[],
            lessons:[],
            types:[]
        };
    },
    methods: {
        _getTypes(){
            fb.db.collection("LessonTypes").get().then(querySnapshot=>{
                if(querySnapshot!=null && !querySnapshot.empty){
                    querySnapshot.forEach(schoolData=>{
                        let object=schoolData.data()
                        object.id=schoolData.id
                        this.types.push(object)
                    })
                }
            })
        },
       _getSchools(){
            fb.db.collection("schools").get().then(querySnapshot=>{
                if(querySnapshot!=null && !querySnapshot.empty){
                    querySnapshot.forEach(schoolData=>{
                        let object=schoolData.data()
                        object.id=schoolData.id
                        object.departments=[]
                        this._getDepartments(schoolData, object)
                        this.schools.push(object)
                    })
                }
            })
        },
        _getDepartments(schoolData, school){
            if(schoolData!=null){
                schoolData.ref.collection("departments").get().then(querySnapshot=>{
                    if(querySnapshot!=null && !querySnapshot.empty){
                        querySnapshot.forEach(depData=>{
                            let object=depData.data()
                            object.id=depData.id
                            object.programs=[]
                            this._getPrograms(depData, object)
                            school.departments.push(object)
                        })
                    }
                })
            }
        },
        _getPrograms(depData, department){
            if(depData!=null){
                depData.ref.collection("programs").get().then(querySnapshot=>{
                    if(querySnapshot!=null && !querySnapshot.empty){
                        querySnapshot.forEach(proData=>{
                            let object=proData.data()
                            object.id=proData.id
                            object.lessons=[]
                            this._getLessons(proData, object)
                            department.programs.push(object)
                        })
                    }
                })
            }
        },
        _getLessons(proData, program){
            if(proData!=null){
                fb.db.collection("lessons").where("program", "==", proData.ref).get().then(querySnapshot=>{
                    if(querySnapshot!=null && !querySnapshot.empty){
                        querySnapshot.forEach(lessonData=>{
                            let object=lessonData.data()
                            object.id=lessonData.id
                            // this.types.forEach((type, index)=>{
                            //     object[type.id]=[]
                            //     this._getTopics(lessonData.id, type.id, object[type.id])
                            // })
                            program.lessons.push(object)

                        })
                    }
                })
            }
        },
        _getTopics(lessonId, typeid, item){
            fb.db.collection("lessons").doc(lessonId).collection(typeid).get().then(querySnapshot=>{
                if(querySnapshot!=null && !querySnapshot.empty){
                    querySnapshot.forEach(topicData=>{
                        let object=topicData.data()
                        object.id=topicData.id
                        item.push(object)
                        
                    })
                }
            })
        },
        _getLessonsDefault(){

            fb.db.collection("lessons").where("program", "==", null).get().then(querySnapshot=>{
                if(querySnapshot!=null && !querySnapshot.empty){
                    querySnapshot.forEach(lessonData=>{
                        let object=lessonData.data()
                        object.id=lessonData.id
                        this.types.forEach((type, index)=>{
                            object[type.id]=[]
                            this._getTopics(lessonData.id, type.id, object[type.id])
                        })
                        this.lessons.push(object)
                    })
                }
            })

        },
         goDetail(lesson){
          this.$router.push({ name: 'LessonDetailAdmin', params: { lessonId: lesson.id} })
        }

    },
    created() {
        this._getTypes();
        this._getSchools();  
        this._getLessonsDefault();
    },
};
</script>

